import HomePage from "../pages/home/HomePage";
import DonutSmallIcon from '@mui/icons-material/DonutSmall';
import AutoAwesomeMosaicIcon from '@mui/icons-material/AutoAwesomeMosaic';
import TrackChangesIcon from '@mui/icons-material/TrackChanges';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import { TargetPrediction } from "../pages/prediction/target/TargetPrediction";
import DockIcon from '@mui/icons-material/Dock';
import JoinFullIcon from '@mui/icons-material/JoinFull';
import { ProteinStructPrediction } from "../pages/prediction/protein/ProteinStructPrediction";
import { Similarity } from "../pages/similarity/Similarity";
import { HmdbSearch } from "../pages/hmdb/HmdbSearch";
import { MolDock } from "../pages/autodock/MolDock";
import { AdmetSearch } from "../pages/admet/Admet";
import { JoinLeftOutlined } from "@mui/icons-material";

import OpacityIcon from '@mui/icons-material/Opacity';
import CalculateIcon from '@mui/icons-material/Calculate';
import JoinInnerIcon from '@mui/icons-material/JoinInner';
import WaterDropIcon from '@mui/icons-material/WaterDrop';
import { SolubilityTabs } from "../pages/solubility_predictor/SolubilityPredictor";
import NGLMolViz from "../pages/NGL/NGLMolViz"
import { Drugex } from "../pages/drugex/Drugex";
import DescriptionIcon from '@mui/icons-material/Description';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import DossierGenerator from "../pages/dossier/DossierGenerator";
import { DocsPage } from "../pages/docs/DocsPage";

const appRoutes = [
  {
    index: true,
    element: <HomePage />,
    path: '/home',
    state: 'Dashboard',
    sidebarProps: {
      displayText: 'Dashboard',
      icon: <AutoAwesomeMosaicIcon />,
    },
  },
  {
    index: true,
    path: '/similarity',
    element: <Similarity />,
    state: 'Similarity',
    sidebarProps: {
      displayText: 'Similarity',
      icon: <DonutSmallIcon />,
    },
  },
  {
    index: true,
    path: '/target-prediction/',
    element: <TargetPrediction />,
    state: 'Prediction',
    sidebarProps: {
      displayText: 'TargetPred',
      icon: <TrackChangesIcon />,
    },
  },
  {
    index: true,
    path: '/protein-struct-prediction',
    element: <ProteinStructPrediction />,
    state: 'ProteinStructurePrediction',
    sidebarProps: {
      displayText: 'ProteinPred',
      icon: <AcUnitIcon />,
    },
  },
  {
    index: true,
    path: '/hmdb',
    element: <HmdbSearch />,
    state: 'HMDB',
    sidebarProps: {
      displayText: 'HMDB',
      icon: <DockIcon />,
    },
  },
  {
    index: true,
    path: "/dock",
    element: <MolDock />,
    state: "Molecular Dock",
    sidebarProps: {
      displayText: "Molecular Dock",
      icon: <JoinFullIcon />
    }
  },
  {
    index: true,
    path: "/admet",
    element: <AdmetSearch />,
    state: "ADMET",
    sidebarProps: {
      displayText: "ADMET",
      icon: <JoinLeftOutlined />
    }
  },
  {
    index: true,
    path: "/MolViz",
    element: <NGLMolViz />,
    state: "MolViz",
    sidebarProps: {
      displayText: "MolViz",
      icon: <JoinLeftOutlined />
    }
  }
  ,
  {
    index: true,
    path: "/SolPred",
    element: <SolubilityTabs />,
    state: "SolPred",
    sidebarProps: {
      displayText: "SolPred",
      icon: <WaterDropIcon />
    }
  }
  ,
  {
    index: true,
    path: "/Drugex",
    element: <Drugex />,
    state: "Drugex",
    sidebarProps: {
      displayText: "Drugex",
      icon: <JoinInnerIcon />
    }
  },
  {
    index: true,
    path: "/dossier",
    element: <DossierGenerator />,
    state: "Dossier 360",
    sidebarProps: {
      displayText: "360° Dossier",
      icon: <DescriptionIcon />
    }
  },
  {
    index: true,
    path: "/docs",
    element: <DocsPage />,
    state: "Docs",
    sidebarProps: {
      displayText: "Docs & Whitepaper",
      icon: <MenuBookIcon />
    }
  }
]

export default appRoutes
